<script setup>
import { computed } from 'vue';

const props = defineProps({
  referral: {
    type: Object,
    required: true,
  },
});

// Messenger/Instagram: source === 'ADS' | WhatsApp: sourceType === 'ad'
const isAdReferral = computed(
  () => props.referral.source === 'ADS' || props.referral.sourceType === 'ad'
);

// Messenger/Instagram uses adsContextData.adTitle; WhatsApp uses headline
const adTitle = computed(
  () => props.referral.adsContextData?.adTitle ?? props.referral.headline ?? ''
);

// Messenger/Instagram uses adsContextData.photoUrl; WhatsApp uses thumbnailUrl
const thumbnailUrl = computed(
  () =>
    props.referral.adsContextData?.photoUrl ?? props.referral.thumbnailUrl ?? ''
);

const hasContent = computed(() => !!(thumbnailUrl.value || adTitle.value));
</script>

<template>
  <div
    v-if="isAdReferral && hasContent"
    class="rounded-lg overflow-hidden border border-n-slate-4 bg-n-alpha-1 -mx-1"
  >
    <img
      v-if="thumbnailUrl"
      :src="thumbnailUrl"
      class="w-full object-cover max-h-48 skip-context-menu"
      alt=""
    />
    <div class="px-3 py-2 flex flex-col gap-0.5">
      <span class="text-xs font-medium text-n-slate-9 uppercase tracking-wide">
        {{ $t('CONVERSATION.AD_REFERRAL.SPONSORED') }}
      </span>
      <p v-if="adTitle" class="m-0 text-sm font-semibold text-n-slate-12">
        {{ adTitle }}
      </p>
    </div>
  </div>
</template>
